import React, { PureComponent } from 'react';
import ScrollToTop from 'components/scroll-to-top';
// import scrollToComponent from 'react-scroll-to-component';
// import { StickyContainer, Sticky } from 'react-sticky';
// import classnames from 'classnames';
import StoriesTemplate from './template';
import { stories, storiesHeader } from './constants';

import './style.css';

class StoriesPage extends PureComponent {
  constructor(props) {
    super(props);
    this.story = {};
  }

  render() {
    return (
      <div className="l-stories-page">
        <ScrollToTop />
        <div className="products-header">
          <h1>{storiesHeader}</h1>
        </div>
        {/* <StickyContainer> */}
        <div className="stories-template">
          {/*   <Sticky
              topOffset={-106}
              bottomOffset={-100}
            >
              {({ style, isSticky }) => (
                <div
                  style={{
                    ...style,
                    ...isSticky && { top: 106 },
                  }}
                  className={classnames({
                    'stories-nav': true,
                    '-sticky': isSticky
                  })}
                >
                  <div className="nav-buttons">
                    {stories.map(story => (
                      <button
                        type="button"
                        key={story.name}
                        className="nav-button"
                        onClick={() => scrollToComponent(this.story[story.name])}>
                        {`${story.name.toUpperCase()}`}
                      </button>))
                    }
                  </div>
                </div>)
              }
            </Sticky> */}
          {stories.map(story => (
            <StoriesTemplate
              key={story.name}
              ref={(r) => { this.story[story.name] = r; }}
              imagePosition={
                stories.indexOf(story) % 2 === 0 ? '-even' : '-odd'
              }
              header={story.header}
              remarkedTitle={story.remarkedTitle}
              title={story.title}
              image={story.name}
              description={story.description}
              pathname={story.pathname}
            />
          ))}
        </div>
        {/* </StickyContainer> */}
      </div>
    );
  }
}

export default StoriesPage;



// WEBPACK FOOTER //
// ./src/pages/stories/index.js